module.exports = (function() { return this["React"]; }());